import axios from 'axios'
import {
  LoginRequest,
  LoginResponse,
  ResendOtpRequest,
  ResetPasswordRequest,
  VerifyOtpRequest,
  VerifyOtpResponse,
} from 'types/Auth'
import { apiv2Client } from './apiv2'

export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
export const EMAIL_OTP = 'EMAIL_OTP'

const urlApi = import.meta.env.VITE_HT_AUTH_API_URL

export const authHTApi = {
  getUserAccessToken: async (body: any) => {
    const response = await axios.post(
      `${urlApi}/public/user/getUserAccessToken`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    return response.data
  },
}

export const login = async (body: LoginRequest): Promise<LoginResponse> =>
  apiv2Client.post('/admin/login', body)

export const resendOtp = async (body: ResendOtpRequest) =>
  apiv2Client.post('/admin/resend-otp', body)

export const verifyOtp = async (
  body: VerifyOtpRequest,
): Promise<VerifyOtpResponse> => apiv2Client.post('/admin/verify-otp', body)

export const resetPassword = async (body: ResetPasswordRequest) =>
  apiv2Client.post('/admin/reset-password', body)
